// extracted by mini-css-extract-plugin
module.exports = {"form":"_4027ad7","heading":"_2c79994","submitBtn":"_60a11e9","text":"_5736ba8","requiredIndicator":"_5e21c2e","error":"_9414c00","success":"_bbf90e0"};